export default "/images/vendor/flag-icon-css/flags/1x1/ye.svg?2289a38ef27f51f7e88a7791dd125021";